import { apiFetch } from "@/utils";

function getAllDeclarations(tierSdcGuid) {
  return apiFetch("frs-hr/declarations?memberGuid=" + tierSdcGuid);
}

function updateDeclaration(pdvGuid, idFrsHr, ca, rfa, hasContract, nbPdv, comment) {
  return apiFetch(`frs-hr/update-declaration?pdvGuid=${pdvGuid}&idFrsHr=${idFrsHr}&ca=${ca}&rfa=${rfa}&hasContract=${hasContract}&nbPdv=${nbPdv}&comment=${comment}`);
}

function endSaisie(pdvGuid) {
  return apiFetch("frs-hr/end-saisie?pdvGuid=" + pdvGuid);
}

function isSaisieEnded(pdvGuid) {
  return apiFetch("frs-hr/is-saisie-ended?pdvGuid=" + pdvGuid);
}

function getAllFrsHR() {
  return apiFetch("frs-hr/fournisseurs");
}

function deleteFrsHR(idFrsHR) {
  return apiFetch("frs-hr/delete-frs?idFrsHR=" + idFrsHR);
}

function getFrsHRContact(idFrsHR) {
  return apiFetch("frs-hr/frs-contacts?idFrsHR=" + idFrsHR);
}

function updateFrsHRContact(idFrsHR, nom, prenom, mail, tel, idContact) {
  return apiFetch(`frs-hr/update-frs-contact?idFrsHR=${idFrsHR}&nom=${nom}&prenom=${prenom}&mail=${mail}&tel=${tel}&idContact=${idContact}`);
}

function deleteFrsHRContact(idContact) {
  return apiFetch("frs-hr/delete-frs-contact?idContactFrsHR=" + idContact);
}

function updateFrsHR(
  IdFrsHR = -1,
  IdFamille = -1,
  IdSousFamille = -1,
  Valide = false,
  Nom = "",
  Ville = "",
  CodePostal = "",
  Siret = "",
  GroupeGuidList = []
) {
  return apiFetch(`frs-hr/update-frs?IdFrsHR=${IdFrsHR}&IdFamille=${IdFamille}&IdSousFamille=${IdSousFamille}&Valide=${Valide}&Nom=${Nom}&Ville=${Ville}&CodePostal=${CodePostal}&Siret=${Siret}&GroupeGuidList=${GroupeGuidList.join(",")}`)
}

function mergeFrsHR(idBaseFrsHR, idFrsHRList) {
  return apiFetch("frs-hr/merge-frs?idBaseFrsHR=" + idBaseFrsHR + "&idFrsHRList=" + (idFrsHRList.join(",")))
}


export default {
  getFrsHRContact,
  updateFrsHRContact,
  deleteFrsHRContact,
  getAllDeclarations,
  updateDeclaration,
  endSaisie,
  isSaisieEnded,
  getAllFrsHR,
  updateFrsHR,
  deleteFrsHR,
  mergeFrsHR
}
export {
  getFrsHRContact,
  updateFrsHRContact,
  deleteFrsHRContact,
  getAllDeclarations,
  updateDeclaration,
  endSaisie,
  isSaisieEnded,
  getAllFrsHR,
  updateFrsHR,
  deleteFrsHR,
  mergeFrsHR
}



// WEBPACK FOOTER //
// ./src/utils/frsHR.js